import {useMemo} from 'react';
import ProductModel from 'coreClasses/product/ProductModel';
import VariantModel from 'coreClasses/product/VariantModel';
import useBannedProducts from './useBannedProducts';
import type {ProductBanFlags} from './useBannedProducts';

export type ProductBannedResult = ProductBanFlags;

/**
 * useBannedProduct delegates to useBannedProducts with a single-item array
 * and returns the ban flags for that product.
 */
export default (product?: ProductModel | VariantModel | null): ProductBannedResult => {
	const productsArray = useMemo(() => {
		return product ? [product] : [];
	}, [product?.product?.type?.placeholder, product?.getUpdateTimestamp()]);
	const {bansByProductId} = useBannedProducts(productsArray);

	const productId = (product as any)?.getProductId?.();

	if (!product || !productId) {
		return {isBannedA: false, isBannedB: false, isBanned: false};
	}

	return bansByProductId[productId] ?? {isBannedA: false, isBannedB: false, isBanned: false};
};
